import ProductApiV2 from '../../../../../lib/api/product/ProductApiV2';
import { PRODUCT_STATUS_V2, ProductItemV2, ProductListRequestOptionV2 } from '../../../../../types/product';
import { SearchOption } from '../../../../../types/common/table';
import { WidgetProductFilterOption } from '../../../../../types/widget';
import { BRAND_STATUS_V2 } from '../../../../../types/brand/common';
import { checkValidId } from '../../../../../lib/utils/common/checkValideId';

export const productListFetcher = async (option: SearchOption<WidgetProductFilterOption>) => {
  const { id, brandId, sort, ...restOption } = option;
  const defaultResult = {
    totalCount: 0,
    products: [],
  };

  const result = checkValidId([id, brandId])
    ? await ProductApiV2.getProductList(
        new ProductListRequestOptionV2({
          id,
          brandId,
          status: PRODUCT_STATUS_V2.NOW_ON_SALE,
          brandStatus: BRAND_STATUS_V2.ACTIVE,
          sort: sort?.length ? sort : ['-id'],
          ...restOption,
        }),
      )
    : defaultResult;

  return {
    totalCount: result.totalCount,
    list: result.products.map((product) => new ProductItemV2(product)),
  };
};
